import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import HowToVoteOutlinedIcon from '@mui/icons-material/HowToVoteOutlined';
import QrCode2OutlinedIcon from '@mui/icons-material/QrCode2Outlined';
import RouteOutlinedIcon from '@mui/icons-material/RouteOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';

import type { DashboardAuth } from '../auth/authStore';

export type NavItem = {
  label: string;
  path: string;
  Icon: typeof DashboardOutlinedIcon;
  roles: readonly DashboardAuth['role'][];
};

export const navItems: readonly NavItem[] = [
  { label: 'Dashboard', path: '/', Icon: DashboardOutlinedIcon, roles: ['broker'] },
  {
    label: 'Canvassing Sessions',
    path: '/canvassing-sessions',
    Icon: RouteOutlinedIcon,
    roles: ['broker'],
  },
  { label: 'Door Visits', path: '/door-visits', Icon: GroupsOutlinedIcon, roles: ['broker'] },
  { label: 'Voters', path: '/voters', Icon: HowToVoteOutlinedIcon, roles: ['broker'] },
  { label: 'Canvasser Onboarding', path: '/onboard-canvassers', Icon: QrCode2OutlinedIcon, roles: ['broker'] },
  { label: 'Seed Data', path: '/seed-data', Icon: UploadFileOutlinedIcon, roles: ['broker'] },
  { label: 'Home', path: '/', Icon: HomeOutlinedIcon, roles: ['agent'] },
];

export const getVisibleNavItems = (role: DashboardAuth['role']): NavItem[] =>
  navItems.filter(item => item.roles.includes(role));

export const isNavItemActive = (pathname: string, item: NavItem): boolean =>
  item.path === '/' ? pathname === '/' : pathname === item.path || pathname.startsWith(`${item.path}/`);

export const getActiveNavIndex = (pathname: string, items: readonly NavItem[]): number | false => {
  const index = items.findIndex(item => isNavItemActive(pathname, item));

  return index === -1 ? false : index;
};
